import { SVGProps } from 'react';

const AutoSearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.93 7.865a.5.5 0 0 1 .14.99 1.836 1.836 0 0 0-1.48 1.235 1.836 1.836 0 0 0 1.319 2.364 1.834 1.834 0 0 0 2.236-1.525l.024-.099a.5.5 0 0 1 .965.24l-.034.194a2.833 2.833 0 1 1-3.17-3.4ZM11.07 7.865l.194.035a2.835 2.835 0 0 1 1.41 4.773A2.834 2.834 0 0 1 7.9 11.264l-.035-.193-.004-.102a.5.5 0 0 1 .97-.139l.024.099.022.125a1.835 1.835 0 0 0 2.214 1.4 1.833 1.833 0 0 0-.037-3.577l-.125-.022-.098-.025a.5.5 0 0 1 .138-.97l.102.005Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.392 2.915a.5.5 0 0 1 .692.694l-.064.078-1.72 1.72a1 1 0 0 1 .033.26v2.666a1 1 0 0 1-.035.258l1.722 1.722.064.079a.5.5 0 0 1-.692.692l-.08-.064-1.72-1.722a1 1 0 0 1-.259.035H5.666a.998.998 0 0 1-.258-.035L3.687 11.02a.5.5 0 0 1-.707-.707L4.702 8.59a1.002 1.002 0 0 1-.036-.257V5.666l.005-.102a.993.993 0 0 1 .03-.155L2.98 3.687l-.065-.078a.5.5 0 0 1 .694-.694l.078.065 1.72 1.72c.083-.022.17-.034.26-.034h2.666l.102.005c.053.006.106.016.156.03l1.722-1.721.079-.065ZM6.666 7.333h.667v-.667h-.667v.667Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M2.68.573a2.836 2.836 0 0 1 2.825.941c.337.404.555.894.63 1.415a.5.5 0 1 1-.99.142A1.837 1.837 0 0 0 3.91 1.59 1.835 1.835 0 0 0 1.59 3.91a1.836 1.836 0 0 0 1.48 1.235.5.5 0 0 1-.14.99 2.835 2.835 0 0 1-2.288-1.91A2.836 2.836 0 0 1 2.679.574ZM9.774.642a2.835 2.835 0 0 1 3.584 3.584 2.835 2.835 0 0 1-2.287 1.908l-.102.005a.5.5 0 0 1-.04-.994l.125-.023a1.833 1.833 0 1 0-2.2-2.051l-.494-.072-.495-.07A2.836 2.836 0 0 1 9.774.642Z"
    />
    <path fill="currentColor" d="M8.855 3.07a.5.5 0 0 1-.99-.141l.99.142Z" />
  </svg>
);

export default AutoSearchIcon;
